import PropTypes from 'prop-types';
import React from 'react';
import ImpressionWatcher from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionEntity } from 'js/utils/impressions/watchImpressions';
import RedesignedMentionsPing from './redesigned_mentions_ping.wjs';

class MentionsPing extends RedesignedMentionsPing {
  getBody() {
    return this.props.type === 'paper'
      ? this.getPaperText()
      : this.getAuthorText();
  }

  getUpgradeURL() {
    return $r.upgrade_url({
      feature: 'searchm',
      trigger: 'mentions-view-download-onsite-ping',
      after_upgrade_path: encodeURIComponent($r.mentions_path()),
    });
  }

  getPaperText() {
    const article = $h.aOrAn(this.props.researchInterestName);
    return (
      <div className="text">
        The name <strong>{this.props.mentionedName}</strong> is mentioned in{' '}
        {article} <strong>{this.props.researchInterestName}</strong> paper
        uploaded to Academia.
      </div>
    );
  }

  getAuthorText() {
    const article = $h.aOrAn(this.props.researchInterestName);
    return (
      <div className="text">
        The name <strong>{this.props.mentionedName}</strong> is mentioned by{' '}
        {article} <strong>{this.props.researchInterestName}</strong> researcher
        in a paper uploaded to Academia.
      </div>
    );
  }

  getCopyString() {
    const article = $h.aOrAn(this.props.researchInterestName);
    return this.props.type === 'paper'
      ? `The name ${this.props.mentionedName} is mentioned in ${article} ${this.props.researchInterestName} paper uploaded to Academia.`
      : `The name ${this.props.mentionedName} is mentioned by ${article} ${this.props.researchInterestName} researcher in a paper uploaded to Academia.`;
  }

  render() {
    const extra = {
      researchInterestId: this.props.researchInterestId,
      mentionId: this.props.mentionId,
      copy: this.getCopyString(),
    };

    return (
      <ImpressionWatcher
        entityId={0}
        entityType={ImpressionEntity.UnMapped}
        source="mentions_view_download_research_interest_ping"
        extra={extra}
      >
        {super.render()}
      </ImpressionWatcher>
    );
  }
}

MentionsPing.propTypes = {
  mentionId: PropTypes.number.isRequired,
  researchInterestId: PropTypes.number.isRequired,
  mentionedName: PropTypes.string.isRequired,
  researchInterestName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default MentionsPing;
